import type {FC} from 'react';
import Link from 'next/link';

import type {ButtonProps} from '@/modules/foundation/components/button';
import {Button} from '@/modules/foundation/components/button';

export type CallToActionProps = {
	href: string;
	targetBlank?: boolean;
	text: string;
	intent?: ButtonProps['intent'];
};

export const CallToAction: FC<CallToActionProps> = ({href, targetBlank, text, intent}) => {
	return (
		<Button asChild intent={intent}>
			<Link href={href} {...(targetBlank && {target: '_blank'})}>
				{text}
			</Link>
		</Button>
	);
};
